module.exports = __webpack_public_path__ + "img/28.6a319b84.jpg";